import { PlanComponentCategory } from "../types/AnalyzedPlan.js";

export const planComponentCategoryLabelMap = {
  [PlanComponentCategory.CutEnergyWaste]: "Cut Energy Waste",
  [PlanComponentCategory.ElectrifyMobile]: "Electrify (mobile)",
  [PlanComponentCategory.ElectrifyStationary]: "Electrify (stationary)",
  [PlanComponentCategory.BuyClean]: "Buy Clean",
  [PlanComponentCategory.Other]: "Other",
};
